"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateSlipBatchMutation = exports.useFetchStoredSlipsQuery = exports.slipApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.slipApi = (0, react_1.createApi)({
    reducerPath: "slipApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["storedSlips"],
    endpoints: function (builder) { return ({
        fetchStoredSlips: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId, period = _a.period;
                return ({
                    url: "/v1/slip/stored",
                    method: "GET",
                    params: __assign({ clientId: clientId, buildingId: buildingId }, (period ? { period: period } : {})),
                });
            },
            providesTags: ["storedSlips"],
        }),
        generateSlipBatch: builder.mutation({
            query: function (body) { return ({
                url: "/v1/slip/store/batch",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["storedSlips"],
        }),
    }); },
});
exports.useFetchStoredSlipsQuery = exports.slipApi.useFetchStoredSlipsQuery, exports.useGenerateSlipBatchMutation = exports.slipApi.useGenerateSlipBatchMutation;
